import { useMemo } from "react";
import getIsServiceCreated from "./getIsServiceCreated";
export const useIsHomeVideoReviewReadyToBeCreated = ({ avForums, avNirvana, avsForum, bluRay, bluRayAuthority, digitalBits, doBlu, effectiveImdbId, hidefDigest, highDefDiscNews, homeTheaterForum, homeVideoReview, theaterByte, whySoBlu }) => useMemo(() => Boolean(effectiveImdbId || homeVideoReview.name) &&
    getIsServiceCreated(avForums.url, avForums.isPreviewValid, homeVideoReview.avForumsId) &&
    getIsServiceCreated(avNirvana.url, avNirvana.isPreviewValid, homeVideoReview.avNirvanaId) &&
    getIsServiceCreated(avsForum.url, avsForum.isPreviewValid, homeVideoReview.avsForumId) &&
    getIsServiceCreated(bluRay.url, bluRay.isPreviewValid, homeVideoReview.bluRayId) &&
    getIsServiceCreated(bluRayAuthority.url, bluRayAuthority.isPreviewValid, homeVideoReview.bluRayAuthorityId) &&
    getIsServiceCreated(digitalBits.url, digitalBits.isPreviewValid, homeVideoReview.digitalBitsId) &&
    getIsServiceCreated(doBlu.url, doBlu.isPreviewValid, homeVideoReview.doBluId) &&
    getIsServiceCreated(hidefDigest.url, hidefDigest.isPreviewValid, homeVideoReview.hidefDigestId) &&
    getIsServiceCreated(highDefDiscNews.url, highDefDiscNews.isPreviewValid, homeVideoReview.highDefDiscNewsId) &&
    getIsServiceCreated(homeTheaterForum.url, homeTheaterForum.isPreviewValid, homeVideoReview.homeTheaterForumId) &&
    getIsServiceCreated(theaterByte.url, theaterByte.isPreviewValid, homeVideoReview.theaterByteId) &&
    getIsServiceCreated(whySoBlu.url, whySoBlu.isPreviewValid, homeVideoReview.whySoBluId), [
    avForums,
    avNirvana,
    avsForum,
    bluRay,
    bluRayAuthority,
    digitalBits,
    doBlu,
    effectiveImdbId,
    hidefDigest,
    highDefDiscNews,
    homeTheaterForum,
    homeVideoReview,
    theaterByte,
    whySoBlu
]);
